// Nom de fichier fourni par le serveur (Content-Disposition), sinon le nom de secours.
export const cdName = (header, fallback) => {
  const h = header || "";
  const star = h.match(/filename\*=UTF-8''([^;]+)/i);
  if (star) { try { return decodeURIComponent(star[1]); } catch { /* nom brut */ } }
  const plain = h.match(/filename="?([^";]+)"?/i);
  return plain ? plain[1] : fallback;
};
